import React from 'react';
import { TableRow, TableCell, Skeleton, useTheme } from '@mui/material';

const LoadingStateRow = ({ colSpan }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    // Render 5 placeholder rows to simulate data loading smoothly
    const rows = Array.from(new Array(5));

    return (
        <>
            {rows.map((_, index) => (
                <TableRow key={index} sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
                    {Array.from(new Array(colSpan)).map((_, colIndex) => (
                        <TableCell key={colIndex} sx={{ py: 2 }}>
                            <Skeleton
                                animation="wave"
                                variant="text"
                                sx={{
                                    bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                    height: 24,
                                    borderRadius: 1,
                                    width: colIndex === 0 ? '40%' : colIndex === colSpan - 1 ? '60%' : '80%',
                                }}
                            />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
};

export default LoadingStateRow;
